import { FunctionComponent, ReactNode } from "react";

export interface SliderContentProps {
  children?: ReactNode;
}

const SliderContent: FunctionComponent<SliderContentProps> = ({ children }) => {
  return <div className="w-full relative overflow-hidden">{children}</div>;
};

export default SliderContent;
